import cx from 'classnames';
import React from 'react';
import { BaseTab } from '../base-tab';
import { TabHeaderHorizontalAlignment, TabTraySize, } from '../common';
import styles from './tab.module.scss';
export const Tab = ({ children, size = TabTraySize.Medium, selectedTabId = '', headerAlignment = TabHeaderHorizontalAlignment.LEFT, className = '', tabPanelClassName = '', enableOverflowControls, forceUpdateTabs, ...restProps }) => {
    const tabHeaderClass = cx(styles.tabHeader, className, styles[headerAlignment], styles[size.toLowerCase()], {
        [styles.tabNavHeader]: enableOverflowControls,
    });
    return (React.createElement("div", { className: cx(styles.tabHorizontal), ...restProps }, BaseTab(children, selectedTabId, styles, tabHeaderClass, tabPanelClassName, restProps.hideTabHeader, enableOverflowControls, forceUpdateTabs)));
};
//# sourceMappingURL=tab.js.map